import React from 'react';
import { IconCheck, IconExclamationMark } from '@tabler/icons-react';
import { CImage } from '@app/components/Common';
import { COLORS, IMAGES } from '@app/constants';
import { Text, View } from '@/styles/reactnative';
import { AccountInfoNavBarRightSideSection } from './styles';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Key from '../../../assets/Key.svg?react';

const AccountInfoNavBarRightSide = () => {
  const { t } = useTranslation();
  return (
    <AccountInfoNavBarRightSideSection>
      <View
        style={{
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
        }}
      >
        <IconWrap>
          <Title>{t('SECURITYWARN')}</Title>
          <IconSVG as={Key} />
        </IconWrap>

        <View style={{ flexDirection: 'row', marginTop: 10 }}>
          <View style={{ flexDirection: 'row' }}>
            <IconCheck size={18} style={{ color: COLORS.lightGreen }} />
            <Text size={14} style={{ color: COLORS.lightGreen }}>
              {t('Identity Verification')}
            </Text>
          </View>
          <View style={{ flexDirection: 'row' }}>
            <IconExclamationMark size={18} style={{ color: COLORS.lightRed }} />
            <Text size={14} style={{ color: COLORS.lightRed }}>
              {t('twoFactorAuthentication')}
            </Text>
          </View>
        </View>
      </View>
      {/*<CImage*/}
      {/*  src={IMAGES.securityHigh}*/}
      {/*  alt="logo"*/}
      {/*  width={64}*/}
      {/*  height={64}*/}
      {/*  resizeMode={"cover"}*/}
      {/*/>*/}
    </AccountInfoNavBarRightSideSection>
  );
};

export default AccountInfoNavBarRightSide;

const Title = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16.71px;
  color: ${({ theme }) => theme.text};
`;

const IconWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const IconSVG = styled.svg`
  width: 50px;
  height: 50px;
`;
